var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"uk-button-small primary uk-modal-close",on:{"click":_vm.clicked}},[_vm._v("Place")])])}
var staticRenderFns = []

export { render, staticRenderFns }